import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import ProtectedRoute from 'components/ProtectedRoute';
import Header from 'components/Header';

import Signup from 'pages/Signup';
import Login from 'pages/Login';
import Verification from 'pages/Verification';
import Home from 'pages/Home';
import NotFound from 'pages/NotFound';

const App: React.FC = () => {
  return (
    <Router>
      <Header />
      <Switch>
        <ProtectedRoute path="/" exact>
          <Home />
        </ProtectedRoute>
        <Route path="/login">
          <Login />
        </Route>
        <Route path="/signup" exact>
          <Signup />
        </Route>
        <Route path="/signup/confirm">
          <Verification />
        </Route>
        <Route>
          <NotFound />
        </Route>
      </Switch>
    </Router>
  );
};

export default App;
